import axios from "axios";

export const fetchWorklistAPI = async (payload) => {
    let data = {
        ...payload,
        page: Math.max(0, (payload.page || 1) - 1),
    }
    return await axios.post(`/api/v1/worklist-visits`, data)
        .then(function (response) {  
            if (response.data) {
                return { success: true, data: response.data }
            } else {
                return { success: false, error: response.error }
            }
        }).catch(function (error) {
            return { success: false, error: error }
        })
}

export const updateExaminationStateAPI = async (worklist) => {

    return await axios.post(`/api/v1/update-examination-state`, worklist)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            } else {
                return { success: false, error: response.error }
            }

        }).catch(function (error) {
            return { success: false, error: error }
        })
}

export const fetchAllTechniciansAPI = async () => {

    return await axios.get(`/api/v1/technicians`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            } else {
                return { success: false, error: response.error }
            }

        }).catch(function (error) {
            return { success: false, error: error }
        })
}

export const undoVisitAPI = async (visitNo) => {

    return await axios.get(`/api/v1/undo-visit`, {
        params: {
            visitNo
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            } else {
                return { success: false, error: response.error }
            }

        }).catch(function (error) {
            return { success: false, error: error }
        })
}